import { create } from 'zustand';

import {
  GetDocumentTypesParams,
  getDocumentsType,
  removeDocumentType,
} from '@/shared/actions/erp/';
import { ITipoDocumento } from '@/shared/interfaces/erp';

interface DocumentsTypeState {
  isLoading: boolean;
  tiposDocumento: ITipoDocumento[];

  getTiposDocumento: (params?: GetDocumentTypesParams) => Promise<void>;
  setIsLoading: (isLoading: boolean) => void;
  deleteTipoDocumento: (id: string) => Promise<void>;
}

export const useDocumentTypesStore = create<DocumentsTypeState>((set, get) => ({
  tiposDocumento: [],
  isLoading: false,

  getTiposDocumento: async params => {
    set({ isLoading: true });
    const data = await getDocumentsType(params);
    set({ tiposDocumento: data.data.data, isLoading: false });
  },
  setIsLoading: isLoading => set({ isLoading }),
  deleteTipoDocumento: async id => {
    const tiposDocumento = get().tiposDocumento;

    set({ isLoading: true });
    await removeDocumentType(id);
    set({
      tiposDocumento: tiposDocumento.filter(
        tipoDocumento => tipoDocumento.id_tipo_documento !== id
      ),
      isLoading: false,
    });
  },
}));
